import React, { useState, useCallback } from "react";
import { deleteBoard } from "../../../../../sevices/apiBoards";
import { DeleteIcone } from "../../../../../components/UI/Icons";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { Typography } from "@mui/material";
import useMutate from "../../../../../hooks/useMutate";

function Delete({ id }) {
  const [loading, setLoading] = useState(false);
  const [openDeleteBoardDialog, setOpenDeleteBoardDialog] = useState(false)

  const handleOpenDeleteBoardDialog = useCallback(() => {
    setOpenDeleteBoardDialog(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setOpenDeleteBoardDialog(false);
  }, []);

  const { mutate: deleteMutate } = useMutate(deleteBoard,['boards'],() => {},
    () => {
      setLoading(false);
      //toast.success(res.data.message);
      handleCloseDialog();
    },
    () => {
      setLoading(false);
      handleCloseDialog();
    },
  );

  const submitDeleteBoardDialog = useCallback(() => {
    setLoading(true);
    deleteMutate(id);
  }, [deleteMutate, id]);

  return (
    <>
      <div className="cursor-pointer" onClick={handleOpenDeleteBoardDialog}>
        <DeleteIcone height={"24px"} width={"24px"} />
      </div>
      {openDeleteBoardDialog && (
        <FormDialog
          open={openDeleteBoardDialog}
          handleClose={handleCloseDialog}
          handleSubmit={submitDeleteBoardDialog}
          loading={loading}
          buttonTxt={"Delete"}
          title={"Confirmation: Delete Board"}
          alignActions={"center"}
          btnColor="#B71D18"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to delete this board?
          </Typography>
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(Delete);
